const LOCK_SVG = `
<svg class="lock" width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
  <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"
    d="M12 1.46021C15.3137 1.46021 18 4.1465 18 7.46021L18.0004 10.0606C18.9515 10.2149 19.6776 11.04 19.6776 12.0346V20.5399C19.6776 21.6445 18.7822 22.5399 17.6776 22.5399H6.32239C5.21782 22.5399 4.32239 21.6445 4.32239 20.5399V12.0346C4.32239 11.04 5.04851 10.2149 5.99959 10.0606L5.99999 7.46021C5.99999 4.1465 8.68629 1.46021 12 1.46021ZM12 13.1467C11.0425 13.1467 10.2663 13.9229 10.2663 14.8804C10.2663 15.4119 10.5055 15.8875 10.8821 16.2055L10.9991 16.2961L11 18.4661C11 19.0184 11.4477 19.4661 12 19.4661C12.5128 19.4661 12.9355 19.0801 12.9933 18.5827L13 18.4661L13.0005 16.2964C13.4441 15.9824 13.7336 15.4652 13.7336 14.8804C13.7336 13.9229 12.9575 13.1467 12 13.1467ZM12 3.81758C9.97253 3.81758 8.31695 5.4098 8.21545 7.41205L8.21052 7.63033L8.20939 10.0342H15.7884L15.7895 7.60705C15.7895 5.51419 14.0929 3.81758 12 3.81758Z"/>
</svg>`.trim();

const ARROW_SVG = `
<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
  <path fill-rule="evenodd" clip-rule="evenodd"
        d="M9.99498 13.495L9.00503 12.505L12.8101 8.69998H1.5V7.29998H12.8101L9.00503 3.49495L9.99498 2.505L14.995 7.505V8.49495L9.99498 13.495Z"
        fill="currentColor"/>
</svg>`.trim();

function decideUpsellSize(el) {
  if (el.classList.contains('upsell--banner')) return 'banner';
  if (el.classList.contains('upsell--rect'))   return 'rect';

  const h = el.clientHeight || el.offsetHeight || 0;
  if (h && h <= 90) return 'banner';
  return 'rect';
}

// Upsell Ad Builder (size optional)
window.pPlusUpsell = function pPlusUpsell(adEl, size, opts) {
  if (!adEl) return () => {};

  const finalSize = size || decideUpsellSize(adEl);

  const {
    header  = 'Monitor your health risk',
    content = (finalSize === 'rect') ? 'Customize the health and allergen views that matter most to you' : undefined,
    button  = (finalSize === 'rect') ? 'Explore Premium+' : 'Explore',
    href,
    lock = true,
  } = opts || {};

  adEl.classList.add('upsell');
  adEl.classList.remove('upsell--banner', 'upsell--rect');
  adEl.classList.add(finalSize === 'banner' ? 'upsell--banner' : 'upsell--rect');

  adEl.innerHTML = '';

  const link = document.createElement('a');
  link.className = 'upcard';
  link.href = href || '/account/upsell';
  link.setAttribute('aria-label', header || 'Upgrade to Premium+');
  link.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    window.location.assign(link.href);
  });

  if (lock) link.insertAdjacentHTML('beforeend', LOCK_SVG);

  const h = document.createElement('h4');
  h.className = 'upsell-header';
  h.textContent = header || 'Upgrade to Premium+';
  link.appendChild(h);

  if (content) {
    const p = document.createElement('p');
    p.className = 'upsell-content';
    p.textContent = content;
    link.appendChild(p);
  }

  const btn = document.createElement('div');
  btn.className = 'upsell-btn';

  if (button) {
    const span = document.createElement('span');
    span.className = 'btn-text';
    span.textContent = button;
    btn.appendChild(span);
  }

  btn.insertAdjacentHTML('beforeend', ARROW_SVG);
  link.appendChild(btn);

  adEl.appendChild(link);

  // teardown for convenience
  return function teardown() {
    adEl.classList.remove('upsell', 'upsell--banner', 'upsell--rect');
    adEl.innerHTML = '';
  };
};
